import PageBuilderService from "api/services/page-builder";

export const defaultCalendlyTimeSlots: number = 10;

export enum PageBlockTypes {
    Banner = 'banner',
    BannerTextColumn = 'banner-text-column',
    Heading = 'heading',
    Subtext = 'subtext',
    Text = 'text',
    Image = 'image',
    ImageText = 'image-text',
    ImageTextColumn = 'image-text-column',
    ImageGridText = 'image-grid-text',
    Video = 'video',
    VideoText = 'video-text',
    Button = 'button',
    Pricing = 'pricing',
    Plans = 'plans',
    Event = 'event',
    Events = 'events',
    CourseCurriculum = 'course-curriculum',
    Courses = 'courses',
    FAQ = 'faq',
    CountdownTimer = 'countdown-timer',
    Embed = 'embed',
    Form = 'form',
    Payment = 'payment',
}

export enum PageNavElementTypes {
    Header = 'header',
    Footer = 'footer',
}

export enum VideoType {
    Uplaod = 'Upload',
    WebLink = 'Web link',
}

export enum ButtonAction {
    None = 'none',
    Default = 'default',
    Scroll = 'scroll',
    URL = 'url',
    Popup = 'popup',
    URLTab = 'url-tab',
    Page = 'page',
}

export enum PricePeriod {
    Month = 'month',
    Year = 'year',
    Quarterly = 'every 3 months',
    SemiAnnually = 'every 6 months',
    OneTime = 'one-time',
}

export enum ButtonStyles {
    Flat = 'flat',
    Line = 'line',
    Gradient = 'gradient',
}

export enum BackgroundImageSizing {
    Fit = 'fit',
    Fill = 'fill',
    Auto = 'auto',
}

export enum BackgroundImageRepeat {
    None = 'none',
    Horizontally = 'horizontally',
    Vertically = 'vertically',
    Both = 'both',
}

export enum BackgroundImagePosition {
    Top = 'top',
    Center = 'center',
    Bottom = 'bottom',
}

export enum WidgetType {
    Form = 'form',
    Scheduler = 'scheduler',
    Embed = 'embed',
}

export enum FormFieldTypes {
    FirstName = 'First Name',
    LastName = 'Last Name',
    Email = 'Email',
    PhoneNumber = 'Phone Number',
    UserConsent = 'User Consent',
    Calendly = 'Calendly',
}

export enum LegalLinkTypes {
    PrivacyPolicy = 'Privacy policy',
    TermsOfService = 'Terms of service',
    Cookies = 'Cookies',
}

export enum SchedulerTypes {
    Calendly = 'Calendly',
}

export enum CalendlyType {
    Event = 'Event',
    Link = 'Link',
}

export enum EmbedTypes {
    URL = 'URL',
    Code = 'Code',
}

export enum PaymentBlockPurpose {
    Payment = 'payment',
    Upsell = 'upsell',
}

export enum SellableTypes {
    COURSE = 'courses',
    EVENT = 'events',
    PLAN = 'plans',
    PDF = "pdfs",
    AUDIO = "audios",
    VIDEO = "videos",
    EMBED = "embeds",
    ARTICLE = "articles",
}

export enum ListStyleTypes {
    Disc = 'disc',
    Circle = 'circle',
    Square = 'square',
    Decimal = 'decimal',
    DecimalLeadingZero = 'decimal-leading-zero',
    LowerAlpha = 'lower-alpha',
    LowerGreek = 'lower-greek',
    LowerLatin = 'lower-latin',
    LowerRoman = 'lower-roman',
    UpperAlpha = 'upper-alpha',
    UpperGreek = 'upper-greek',
    UpperLatin = 'upper-latin',
    UpperRoman = 'upper-roman',
    Armenian = 'armenian',
    CJKIdiographic = 'cjk-ideographic',
    Georgian = 'georgian',
    Hebrew = 'hebrew',
    Hiragana = 'hiragana',
    HiraganaIroha = 'hiragana-iroha',
    Katakana = 'katakana',
    KatakanaIroha = 'katakana-iroha',
    None = 'none',
}

export enum Socials {
    Facebook = 'facebook',
    X = 'x',
    LinkedIn = 'linked-in',
    Instagram = 'instagram',
    Website = 'website',
}

export enum Stores {
    PlayStore = 'playstore',
    AppStore = 'appstore',
}

export enum ShadowPosition {
    None = 'None',
    Even = 'Even',
    Top = 'Top',
    Bottom = 'Bottom',
    BottomRight = 'Bottom Right',
    BottomLeft = 'Bottom Left',
    TopRight = 'Top Right',
    TopLeft = 'Top Left',
}

export enum UpsellUrgencyType {
    None = 'None',
    Timer = 'Timer',
    PageExit = 'Page Exit',
}

export enum CountdownTimerType {
    Standard = 'Standard',
    Upsell = 'Upsell',
}

export enum HeaderBehavior {
    Static = 'Static',
    Sticky = 'Sticky',
}

export const getDefaultPageStyles: any = () => {
    return ({
        button: {
            button_style: ButtonStyles.Flat,
            button_text_font_size: 16,
            button_text_line_height: 20,
            button_text_color: '#FFFFFF',
            button_background_color: '#EE8F00',
            button_hover_text_color: null,
            button_border_radius: 4,
            button_shadow_position: ShadowPosition.None,
            button_shadow_color: '#000000',
            button_shadow_opacity: .2,
        },
        fonts: {
            h1: {
                font_family: 'Arial, sans-serif',
                text_color: '#333333',
                font_size: 35,
                line_height: 45,
            },
            h2: {
                font_family: 'Arial, sans-serif',
                text_color: '#333333',
                font_size: 31,
                line_height: 40,
            },
            h3: {
                font_family: 'Arial, sans-serif',
                text_color: '#333333',
                font_size: 27,
                line_height: 35,
            },
            p: {
                font_family: 'Arial, sans-serif',
                text_color: '#666666',
                font_size: 20,
                line_height: 25,
            },
        },
        background: {
            background_color: '#FAFAFA',
            background_image_url: null,
            background_image_color_overlay: null,
            background_image_sizing: BackgroundImageSizing.Fit,
            background_image_position: BackgroundImagePosition.Top,
            background_image_repeat: BackgroundImageRepeat.Both,
            extend_section_background: false,
            background_opacity: 1,
        },
    });
}

export const getDefaultPageBlockData: any = (pageBlockType: PageBlockTypes, pageStyles: any) => {
    switch(pageBlockType) {
        case PageBlockTypes.Banner:
            return ({
                name: '',
                type: pageBlockType,
                image_alt: 'example banner',
                image_url: 'https://static.group.app/blocks/images/otYFmmuB0V_kidos_testplan_post__pexels-fauxels-3184302.jpg',
                heading: '<h1><strong>Example Banner</strong></h1>',
                heading_json: `{"blocks":[{"key":"3s2ed","text":"Example Banner","type":"header-one","depth":0,"inlineStyleRanges":[{"offset":0,"length":14,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                subtext: '<p><strong>Showcase your course or coaching, an announcement, or big feature. Use an eye-catching subheader to give your audience more context</strong></p>',
                subtext_json: `{"blocks":[{"key":"bd1qb","text":"Showcase your course or coaching, an announcement, or big feature. Use an eye-catching subheader to give your audience more context","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":131,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                button_shown: true,
                button_action: ButtonAction.URL,
                button_text: '[Set button action]',
                button_url: '#',
                button_url_label: '',
                button_url_page_id: null,
                side_by_side_button: false,
                design: {
                    container_background_color: null,
                    container_padding_top: 120,
                    container_padding_bottom: 120,
                    content_container_max_width: 772,
                    image_opacity: 1,
                    image_gradient_opacity: .4,
                    text_alignment: 'center',
                    button_text_font_size: pageStyles ? pageStyles.button_text_font_size : 16,
                    button_text_line_height: pageStyles ? pageStyles.button_text_line_height : 20,
                    button_border_radius: pageStyles ? pageStyles.button.button_border_radius : 4,
                    button_background_color: pageStyles ? pageStyles.button.button_background_color : '#EE8F00',
                    button_text_color: pageStyles ? pageStyles.button.button_text_color : '#FFFFFF',
                    button_shadow_position: pageStyles ? pageStyles.button.button_shadow_position : ShadowPosition.None,
                    button_shadow_color: pageStyles ? pageStyles.button.button_shadow_color : '#000000',
                    button_shadow_opacity: pageStyles ? pageStyles.button.button_shadow_opacity : .2,
                    list_style_type: ListStyleTypes.Disc,
                    list_marker_color: undefined,

                    //heading properties
                    heading_font_family: 'Arial, sans-serif',
                    heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    heading_font_size: 35,
                    heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    heading_line_height: 45,
                    heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    heading_color: '#FFFFFF',
                    heading_h1_color: '#FFFFFF',
                    heading_h2_color: '#FFFFFF',
                    heading_h3_color: '#FFFFFF',
                    heading_p_color: '#FFFFFF',

                    //subtext properties
                    subtext_font_family: 'Arial, sans-serif',
                    subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    subtext_font_size: 20,
                    subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    subtext_line_height: 25,
                    subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    subtext_color: '#FFFFFF',
                    subtext_h1_color: '#FFFFFF',
                    subtext_h2_color: '#FFFFFF',
                    subtext_h3_color: '#FFFFFF',
                    subtext_p_color: '#FFFFFF',
                },
                side_by_side_buttons: [],
            });
        case PageBlockTypes.BannerTextColumn:
            return ({
                name: '',
                type: pageBlockType,
                image_alt: 'example banner',
                image_url: 'https://static.group.app/blocks/images/otYFmmuB0V_kidos_testplan_post__pexels-fauxels-3184302.jpg',
                heading: '<h1><strong>Example Banner</strong></h1>',
                heading_json: `{"blocks":[{"key":"3s2ed","text":"Example Banner","type":"header-one","depth":0,"inlineStyleRanges":[{"offset":0,"length":14,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                subtext: '<p><strong>Showcase your course or coaching, an announcement, or big feature. Use an eye-catching subheader to give your audience more context</strong></p>',
                subtext_json: `{"blocks":[{"key":"bd1qb","text":"Showcase your course or coaching, an announcement, or big feature. Use an eye-catching subheader to give your audience more context","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":131,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                button_shown: true,
                button_action: ButtonAction.URL,
                button_text: '[Set button action]',
                button_url: '#',
                button_url_label: '',
                button_url_page_id: null,
                side_by_side_button: false,
                design: {
                    container_background_color: null,
                    container_padding_top: 120,
                    container_padding_bottom: 120,
                    content_container_max_width: 772,
                    image_opacity: 1,
                    image_gradient_opacity: .4,
                    text_alignment: 'center',
                    button_text_font_size: pageStyles ? pageStyles.button_text_font_size : 16,
                    button_text_line_height: pageStyles ? pageStyles.button_text_line_height : 20,
                    button_border_radius: pageStyles ? pageStyles.button.button_border_radius : 4,
                    button_background_color: pageStyles ? pageStyles.button.button_background_color : '#EE8F00',
                    button_text_color: pageStyles ? pageStyles.button.button_text_color : '#FFFFFF',
                    button_shadow_position: pageStyles ? pageStyles.button.button_shadow_position : ShadowPosition.None,
                    button_shadow_color: pageStyles ? pageStyles.button.button_shadow_color : '#000000',
                    button_shadow_opacity: pageStyles ? pageStyles.button.button_shadow_opacity : .2,
                    list_style_type: ListStyleTypes.Disc,
                    list_marker_color: undefined,
                    column_container_background_color: '#FFFFFF',
                    column_container_padding_top: 20,
                    column_container_padding_bottom: 20,
                    column_container_padding_left: 20,
                    column_container_padding_right: 20,
                    column_container_border_radius: 1,
                    column_container_border_color: null,
                    column_container_border_width: 1,
                    column_container_shadow_position: ShadowPosition.None,
                    column_container_shadow_color: '#000000',
                    column_container_shadow_opacity: .2,

                    //heading properties
                    heading_font_family: 'Arial, sans-serif',
                    heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    heading_font_size: 35,
                    heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    heading_line_height: 45,
                    heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    heading_color: '#000000',
                    heading_h1_color: '#000000',
                    heading_h2_color: '#000000',
                    heading_h3_color: '#000000',
                    heading_p_color: '#000000',

                    //subtext properties
                    subtext_font_family: 'Arial, sans-serif',
                    subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    subtext_font_size: 20,
                    subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    subtext_line_height: 25,
                    subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    subtext_color: '#000000',
                    subtext_h1_color: '#000000',
                    subtext_h2_color: '#000000',
                    subtext_h3_color: '#000000',
                    subtext_p_color: '#000000',
                },
                side_by_side_buttons: [],
            });
        case PageBlockTypes.Heading:
            return ({
                name: '',
                type: pageBlockType,
                heading: '<h1><strong>Example Text</strong></h1>',
                heading_json: `{"blocks":[{"key":"92iva","text":"Example Text","type":"header-one","depth":0,"inlineStyleRanges":[{"offset":0,"length":12,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                design: {
                    container_background_color: null,
                    container_padding_top: 20,
                    container_padding_bottom: 20,
                    content_container_max_width: 772,
                    text_alignment: 'center',
                    list_style_type: ListStyleTypes.Disc,
                    list_marker_color: undefined,

                    //heading properties
                    heading_font_family: 'Arial, sans-serif',
                    heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    heading_font_size: 35,
                    heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    heading_line_height: 45,
                    heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    heading_color: '#000000',
                    heading_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
                    heading_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
                    heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
                    heading_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',
                },
            });
        case PageBlockTypes.Subtext:
            return ({
                name: '',
                type: pageBlockType,
                text: `<p>Use this Text block to tell your course or coaching’s story. Write anything from one-liners to detailed paragraphs that tell your visitors more about what you’re selling. This block - along with other blocks that contain text content - supports various text formatting such as header sizes, font styles, alignment, ordered and unordered lists, hyperlinks and colors.</p>`,
                text_json: `{"blocks":[{"key":"bpgvj","text":"Use this Text block to tell your course or coaching’s story. Write anything from one-liners to detailed paragraphs that tell your visitors more about what you’re selling. This block - along with other blocks that contain text content - supports various text formatting such as header sizes, font styles, alignment, ordered and unordered lists, hyperlinks and colors.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                design: {
                    container_background_color: null,
                    container_padding_top: 20,
                    container_padding_bottom: 20,
                    content_container_max_width: 772,
                    text_alignment: 'center',
                    list_style_type: ListStyleTypes.Disc,
                    list_marker_color: undefined,

                    //subtext properties
                    subtext_font_family: 'Arial, sans-serif',
                    subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    subtext_font_size: 20,
                    subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    subtext_line_height: 25,
                    subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    text_color: '#666666',
                    subtext_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#666666',
                    subtext_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#666666',
                    subtext_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#666666',
                    subtext_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#666666',
                },
            });
        case PageBlockTypes.Text:
            return ({
                name: '',
                type: pageBlockType,
                heading: '<h1><strong>Example Text</strong></h1>',
                heading_json: `{"blocks":[{"key":"92iva","text":"Example Text","type":"header-one","depth":0,"inlineStyleRanges":[{"offset":0,"length":12,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                text: `<p>Use this Text block to tell your course or coaching’s story. Write anything from one-liners to detailed paragraphs that tell your visitors more about what you’re selling. This block - along with other blocks that contain text content - supports various text formatting such as header sizes, font styles, alignment, ordered and unordered lists, hyperlinks and colors.</p>`,
                text_json: `{"blocks":[{"key":"bpgvj","text":"Use this Text block to tell your course or coaching’s story. Write anything from one-liners to detailed paragraphs that tell your visitors more about what you’re selling. This block - along with other blocks that contain text content - supports various text formatting such as header sizes, font styles, alignment, ordered and unordered lists, hyperlinks and colors.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                design: {
                    container_background_color: null,
                    container_padding_top: 20,
                    container_padding_bottom: 20,
                    content_container_max_width: 772,
                    text_alignment: 'center',
                    list_style_type: ListStyleTypes.Disc,
                    list_marker_color: undefined,

                    //heading properties
                    heading_font_family: 'Arial, sans-serif',
                    heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    heading_font_size: 35,
                    heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    heading_line_height: 45,
                    heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    heading_color: '#000000',
                    heading_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
                    heading_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
                    heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
                    heading_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

                    //subtext properties
                    subtext_font_family: 'Arial, sans-serif',
                    subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    subtext_font_size: 20,
                    subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    subtext_line_height: 25,
                    subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    text_color: '#666666',
                    subtext_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#666666',
                    subtext_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#666666',
                    subtext_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#666666',
                    subtext_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#666666',
                },
            });
        case PageBlockTypes.Image:
            return ({
                name: '',
                type: pageBlockType,
                image_alt: 'example canvas',
                image_url: 'https://static.group.app/blocks/images/BdmxQX8MRV_kidos_testplan_post__pexels-ketut-subiyanto-4126724.jpg',
                image_action: ButtonAction.URLTab,
                image_link: '#',
                image_link_label: '',
                image_link_page_id: null,
                design: {
                    container_background_color: null,
                    container_padding_top: 20,
                    container_padding_bottom: 20,
                    content_container_max_width: 772,
                    image_border_radius: 1,
                    image_full_width: false,
                    image_width: null,
                    image_alignment: 'center',
                },
            });
        case PageBlockTypes.ImageText:
            return ({
                name: '',
                type: pageBlockType,
                image_alt: 'example canvas',
                image_url: 'https://static.group.app/blocks/images/84S4PhSn9K_kidos_testplan_post__pexels-fauxels-3184170.jpg',
                image_action: ButtonAction.URLTab,
                image_link: '#',
                image_link_label: '',
                image_link_page_id: null,
                heading: `<h1><strong>Example Text</strong></h1>`,
                heading_json: `{"blocks":[{"key":"e9rfm","text":"Example Text","type":"header-one","depth":0,"inlineStyleRanges":[{"offset":0,"length":12,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                subtext: `<p>Use this Image with Text block to balance out your text content with a complementary visual to strengthen messaging and help your students connect with your product, course, or coaching. You can introduce yourself with a profile picture and author bio, showcase a student testimonial with their smiling face, or highlight an experience with a screenshot.</p>`,
                subtext_json: `{"blocks":[{"key":"91h6j","text":"Use this Image with Text block to balance out your text content with a complementary visual to strengthen messaging and help your students connect with your product, course, or coaching. You can introduce yourself with a profile picture and author bio, showcase a student testimonial with their smiling face, or highlight an experience with a screenshot.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                image_layout: 'left',
                button_shown: true,
                button_action: ButtonAction.URL,
                button_text: '[Set button action]',
                button_url: '#',
                button_url_label: '',
                button_url_page_id: null,
                side_by_side_button: false,
                design: {
                    container_background_color: null,
                    container_padding_top: 20,
                    container_padding_bottom: 20,
                    content_container_max_width: 872,
                    text_alignment: 'center',
                    image_border_radius: 4,
                    image_width: null,
                    button_text_font_size: pageStyles ? pageStyles.button_text_font_size : 16,
                    button_text_line_height: pageStyles ? pageStyles.button_text_line_height : 20,
                    button_border_radius: pageStyles ? pageStyles.button.button_border_radius : 4,
                    button_background_color: pageStyles ? pageStyles.button.button_background_color : '#EE8F00',
                    button_text_color: pageStyles ? pageStyles.button.button_text_color : '#FFFFFF',
                    button_shadow_position: pageStyles ? pageStyles.button.button_shadow_position : ShadowPosition.None,
                    button_shadow_color: pageStyles ? pageStyles.button.button_shadow_color : '#000000',
                    button_shadow_opacity: pageStyles ? pageStyles.button.button_shadow_opacity : .2,
                    list_style_type: ListStyleTypes.Disc,
                    list_marker_color: undefined,

                    //heading properties
                    heading_font_family: 'Arial, sans-serif',
                    heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    heading_font_size: 35,
                    heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    heading_line_height: 45,
                    heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    heading_color: '#000000',
                    heading_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
                    heading_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
                    heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
                    heading_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

                    //subtext properties
                    subtext_font_family: 'Arial, sans-serif',
                    subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    subtext_font_size: 20,
                    subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    subtext_line_height: 25,
                    subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    subtext_color: '#666666',
                    subtext_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#666666',
                    subtext_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#666666',
                    subtext_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#666666',
                    subtext_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#666666',
                },
                side_by_side_buttons: [],
            });
        case PageBlockTypes.ImageTextColumn:
            return ({
                name: '',
                type: pageBlockType,
                image_shown: true,
                image_alt: 'example canvas',
                image_url: 'https://static.group.app/blocks/images/84S4PhSn9K_kidos_testplan_post__pexels-fauxels-3184170.jpg',
                image_action: ButtonAction.URLTab,
                image_link: '#',
                image_link_label: '',
                image_link_page_id: null,
                heading: `<h1><strong>Example Text</strong></h1>`,
                heading_json: `{"blocks":[{"key":"e9rfm","text":"Example Text","type":"header-one","depth":0,"inlineStyleRanges":[{"offset":0,"length":12,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                subtext: `<p>Use this Image with Text block to balance out your text content with a complementary visual to strengthen messaging and help your students connect with your product, course, or coaching. You can introduce yourself with a profile picture and author bio, showcase a student testimonial with their smiling face, or highlight an experience with a screenshot.</p>`,
                subtext_json: `{"blocks":[{"key":"91h6j","text":"Use this Image with Text block to balance out your text content with a complementary visual to strengthen messaging and help your students connect with your product, course, or coaching. You can introduce yourself with a profile picture and author bio, showcase a student testimonial with their smiling face, or highlight an experience with a screenshot.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                image_layout: 'left',
                button_shown: true,
                button_action: ButtonAction.URL,
                button_text: '[Set button action]',
                button_url: '#',
                button_url_label: '',
                button_url_page_id: null,
                side_by_side_button: false,
                design: {
                    container_background_color: null,
                    container_padding_top: 20,
                    container_padding_bottom: 20,
                    content_container_max_width: 872,
                    column_container_background_color: null,
                    column_container_padding_top: 20,
                    column_container_padding_bottom: 20,
                    column_container_padding_left: 20,
                    column_container_padding_right: 20,
                    column_container_border_radius: 1,
                    column_container_border_color: '#D5D8DF',
                    column_container_border_width: 1,
                    column_container_shadow_position: ShadowPosition.None,
                    column_container_shadow_color: '#000000',
                    column_container_shadow_opacity: .2,
                    text_alignment: 'center',
                    image_border_radius: 4,
                    button_text_font_size: pageStyles ? pageStyles.button_text_font_size : 16,
                    button_text_line_height: pageStyles ? pageStyles.button_text_line_height : 20,
                    button_border_radius: pageStyles ? pageStyles.button.button_border_radius : 4,
                    button_background_color: pageStyles ? pageStyles.button.button_background_color : '#EE8F00',
                    button_text_color: pageStyles ? pageStyles.button.button_text_color : '#FFFFFF',
                    button_shadow_position: pageStyles ? pageStyles.button.button_shadow_position : ShadowPosition.None,
                    button_shadow_color: pageStyles ? pageStyles.button.button_shadow_color : '#000000',
                    button_shadow_opacity: pageStyles ? pageStyles.button.button_shadow_opacity : .2,
                    list_style_type: ListStyleTypes.Disc,
                    list_marker_color: undefined,

                    //heading properties
                    heading_font_family: 'Arial, sans-serif',
                    heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    heading_font_size: 35,
                    heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    heading_line_height: 45,
                    heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    heading_color: '#000000',
                    heading_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
                    heading_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
                    heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
                    heading_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

                    //subtext properties
                    subtext_font_family: 'Arial, sans-serif',
                    subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    subtext_font_size: 20,
                    subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    subtext_line_height: 25,
                    subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    subtext_color: '#666666',
                    subtext_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#666666',
                    subtext_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#666666',
                    subtext_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#666666',
                    subtext_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#666666',
                },
                side_by_side_buttons: [],
            });
        case PageBlockTypes.ImageGridText:
            return ({
                name: '',
                type: pageBlockType,
                blocks: [
                    {
                        type: pageBlockType,
                        attachment_type: 'image',
                        attachment_shown: true,
                        video_type: VideoType.Uplaod,
                        video_url: null,
                        file: null,
                        image_alt: 'example canvas',
                        image_url: 'https://static.group.app/blocks/images/BdmxQX8MRV_kidos_testplan_post__pexels-ketut-subiyanto-4126724.jpg',
                        image_action: ButtonAction.URLTab,
                        image_link: '#',
                        image_link_label: '',
                        image_link_page_id: null,
                        heading: `<h2><strong>Example Text</strong></h2>`,
                        heading_json: `{"blocks":[{"key":"e9rfm","text":"Example Text","type":"header-two","depth":0,"inlineStyleRanges":[{"offset":0,"length":12,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                        subtext: `<p>Use this block to showcase testimonials, features, categories, or more. Each column has its own individual text field. You can also leave the text blank to have it display nothing and just showcase an image.</p>`,
                        subtext_json: `{"blocks":[{"key":"91h6j","text":"Use this block to showcase testimonials, features, categories, or more. Each column has its own individual text field. You can also leave the text blank to have it display nothing and just showcase an image.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                        button_shown: true,
                        button_action: ButtonAction.URL,
                        button_text: '[Set button action]',
                        button_url: '#',
                        button_url_label: '',
                        button_url_page_id: null,
                        side_by_side_button: false,
                        side_by_side_buttons: [],
                    },
                    {
                        type: pageBlockType,
                        attachment_type: 'image',
                        attachment_shown: true,
                        video_type: VideoType.Uplaod,
                        video_url: null,
                        file: null,
                        image_alt: 'example canvas',
                        image_url: 'https://static.group.app/blocks/images/BdmxQX8MRV_kidos_testplan_post__pexels-ketut-subiyanto-4126724.jpg',
                        image_action: ButtonAction.URLTab,
                        image_link: '#',
                        image_link_label: '',
                        image_link_page_id: null,
                        heading: `<h2><strong>Example Text</strong></h2>`,
                        heading_json: `{"blocks":[{"key":"e9rfm","text":"Example Text","type":"header-two","depth":0,"inlineStyleRanges":[{"offset":0,"length":12,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                        subtext: `<p>Use this block to showcase testimonials, features, categories, or more. Each column has its own individual text field. You can also leave the text blank to have it display nothing and just showcase an image.</p>`,
                        subtext_json: `{"blocks":[{"key":"91h6j","text":"Use this block to showcase testimonials, features, categories, or more. Each column has its own individual text field. You can also leave the text blank to have it display nothing and just showcase an image.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                        button_shown: true,
                        button_action: ButtonAction.URL,
                        button_text: '[Set button action]',
                        button_url: '#',
                        button_url_label: '',
                        button_url_page_id: null,
                        side_by_side_button: false,
                        side_by_side_buttons: [],
                    },
                    {
                        type: pageBlockType,
                        attachment_type: 'image',
                        attachment_shown: true,
                        video_type: VideoType.Uplaod,
                        video_url: null,
                        file: null,
                        image_alt: 'example canvas',
                        image_url: 'https://static.group.app/blocks/images/BdmxQX8MRV_kidos_testplan_post__pexels-ketut-subiyanto-4126724.jpg',
                        image_action: ButtonAction.URLTab,
                        image_link: '#',
                        image_link_label: '',
                        image_link_page_id: null,
                        heading: `<h2><strong>Example Text</strong></h2>`,
                        heading_json: `{"blocks":[{"key":"e9rfm","text":"Example Text","type":"header-two","depth":0,"inlineStyleRanges":[{"offset":0,"length":12,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                        subtext: `<p>Use this block to showcase testimonials, features, categories, or more. Each column has its own individual text field. You can also leave the text blank to have it display nothing and just showcase an image.</p>`,
                        subtext_json: `{"blocks":[{"key":"91h6j","text":"Use this block to showcase testimonials, features, categories, or more. Each column has its own individual text field. You can also leave the text blank to have it display nothing and just showcase an image.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                        button_shown: true,
                        button_action: ButtonAction.URL,
                        button_text: '[Set button action]',
                        button_url: '#',
                        button_url_label: '',
                        button_url_page_id: null,
                        side_by_side_button: false,
                        side_by_side_buttons: [],
                    },
                ],
                design: {
                    container_background_color: null,
                    container_padding_top: 20,
                    container_padding_bottom: 20,
                    content_container_max_width: 772,
                    content_container_alignment: 'center',
                    text_alignment: 'center',
                    image_border_radius: 4,
                    image_width: null,
                    button_text_font_size: pageStyles ? pageStyles.button_text_font_size : 16,
                    button_text_line_height: pageStyles ? pageStyles.button_text_line_height : 20,
                    button_border_radius: pageStyles ? pageStyles.button.button_border_radius : 4,
                    button_background_color: pageStyles ? pageStyles.button.button_background_color : '#EE8F00',
                    button_text_color: pageStyles ? pageStyles.button.button_text_color : '#FFFFFF',
                    button_shadow_position: pageStyles ? pageStyles.button.button_shadow_position : ShadowPosition.None,
                    button_shadow_color: pageStyles ? pageStyles.button.button_shadow_color : '#000000',
                    button_shadow_opacity: pageStyles ? pageStyles.button.button_shadow_opacity : .2,
                    single_container_background_color: '#FAFAFA',
                    single_container_border_color: '#FAFAFA',
                    single_container_border_width: 1,
                    single_container_border_radius: 4,
                    single_container_shadow_position: ShadowPosition.None,
                    single_container_shadow_color: '#000000',
                    single_container_shadow_opacity: .2,
                    cards_per_row: 3,
                    gutter_height: 10,
                    list_style_type: ListStyleTypes.Disc,
                    list_marker_color: undefined,

                    //heading properties
                    heading_font_family: 'Arial, sans-serif',
                    heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    heading_font_size: 35,
                    heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    heading_line_height: 45,
                    heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    heading_color: '#000000',
                    heading_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
                    heading_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
                    heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
                    heading_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

                    //subtext properties
                    subtext_font_family: 'Arial, sans-serif',
                    subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    subtext_font_size: 20,
                    subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    subtext_line_height: 25,
                    subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    subtext_color: '#666666',
                    subtext_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#666666',
                    subtext_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#666666',
                    subtext_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#666666',
                    subtext_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#666666',
                },
            })
        case PageBlockTypes.Video:
            return ({
                name: '',
                type: pageBlockType,
                video_type: VideoType.Uplaod,
                video_url: null,
                file: null,
                design: {
                    container_background_color: null,
                    container_padding_top: 20,
                    container_padding_bottom: 20,
                    content_container_max_width: 772,
                },
            });
        case PageBlockTypes.VideoText:
            return ({
                name: '',
                type: pageBlockType,
                video_type: VideoType.Uplaod,
                video_url: null,
                file: null,
                heading: `<h1><strong>Example Text</strong></h1>`,
                heading_json: `{"blocks":[{"key":"e9rfm","text":"Example Text","type":"header-one","depth":0,"inlineStyleRanges":[{"offset":0,"length":12,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                subtext: `<p>Use this Video with Text block to balance out your text content with a complementary visual to strengthen messaging and help your students connect with your product, course, or coaching. You can introduce yourself with a profile picture and author bio, showcase a student testimonial with their smiling face, or highlight an experience with a screenshot.</p>`,
                subtext_json: `{"blocks":[{"key":"91h6j","text":"Use this Video with Text block to balance out your text content with a complementary visual to strengthen messaging and help your students connect with your product, course, or coaching. You can introduce yourself with a profile picture and author bio, showcase a student testimonial with their smiling face, or highlight an experience with a screenshot.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                video_layout: 'left',
                button_shown: true,
                button_action: ButtonAction.URL,
                button_text: '[Set button action]',
                button_url: '#',
                button_url_label: '',
                button_url_page_id: null,
                side_by_side_button: false,
                design: {
                    container_background_color: null,
                    container_padding_top: 20,
                    container_padding_bottom: 20,
                    content_container_max_width: 872,
                    text_alignment: 'center',
                    button_text_font_size: pageStyles ? pageStyles.button_text_font_size : 16,
                    button_text_line_height: pageStyles ? pageStyles.button_text_line_height : 20,
                    button_border_radius: pageStyles ? pageStyles.button.button_border_radius : 4,
                    button_background_color: pageStyles ? pageStyles.button.button_background_color : '#EE8F00',
                    button_text_color: pageStyles ? pageStyles.button.button_text_color : '#FFFFFF',
                    button_shadow_position: pageStyles ? pageStyles.button.button_shadow_position : ShadowPosition.None,
                    button_shadow_color: pageStyles ? pageStyles.button.button_shadow_color : '#000000',
                    button_shadow_opacity: pageStyles ? pageStyles.button.button_shadow_opacity : .2,
                    list_style_type: ListStyleTypes.Disc,
                    list_marker_color: undefined,

                    //heading properties
                    heading_font_family: 'Arial, sans-serif',
                    heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    heading_font_size: 35,
                    heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    heading_line_height: 45,
                    heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    heading_color: '#000000',
                    heading_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
                    heading_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
                    heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
                    heading_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

                    //subtext properties
                    subtext_font_family: 'Arial, sans-serif',
                    subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    subtext_font_size: 20,
                    subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    subtext_line_height: 25,
                    subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    subtext_color: '#666666',
                    subtext_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#666666',
                    subtext_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#666666',
                    subtext_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#666666',
                    subtext_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#666666',
                },
                side_by_side_buttons: [],
            });
        case PageBlockTypes.Button:
            return ({
                name: '',
                type: pageBlockType,
                button_action: ButtonAction.URL,
                button_text: '[Set button action]',
                button_url: '#',
                button_url_label: '',
                button_url_page_id: null,
                side_by_side_button: false,
                design: {
                    container_background_color: null,
                    container_padding_top: 20,
                    container_padding_bottom: 20,
                    content_container_max_width: 772,
                    button_text_font_size: pageStyles ? pageStyles.button.button_text_font_size : 16,
                    button_text_line_height: pageStyles ? pageStyles.button.button_text_line_height : 20,
                    button_border_radius: pageStyles ? pageStyles.button.button_border_radius : 4,
                    button_background_color: pageStyles ? pageStyles.button.button_background_color : '#EE8F00',
                    button_text_color: pageStyles ? pageStyles.button.button_text_color : '#FFFFFF',
                    button_alignment: 'center',
                    button_shadow_position: pageStyles ? pageStyles.button.button_shadow_position : ShadowPosition.None,
                    button_shadow_color: pageStyles ? pageStyles.button.button_shadow_color : '#000000',
                    button_shadow_opacity: pageStyles ? pageStyles.button.button_shadow_opacity : .2,
                },
                side_by_side_buttons: [],
            });
        case PageBlockTypes.Pricing:
            return ({
                name: '',
                type: pageBlockType,
                heading: `<h2><strong>Example Text</strong></h2>`,
                heading_json: `{"blocks":[{"key":"e9rfm","text":"Example Text","type":"header-two","depth":0,"inlineStyleRanges":[{"offset":0,"length":12,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                subtext: '<p>Show different pricing options for your community resources.</p>',
                subtext_json: `{"blocks":[{"key":"bd1qb","text":"Show different pricing options for your community resources.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                button_shown: true,
                button_action: ButtonAction.URL,
                button_text: '[Set button action]',
                button_url: '#',
                button_url_label: '',
                button_url_page_id: null,
                side_by_side_button: false,
                blocks: [
                    {
                        type: pageBlockType,
                        title: 'Example Text',
                        text: 'Here you can add a description of your course/product or subscription plan.',
                        currency: 'usd',
                        price: '0',
                        period: PricePeriod.Month,
                        url: '#',
                    }
                ],
                design: {
                    container_background_color: null,
                    container_padding_top: 20,
                    container_padding_bottom: 20,
                    content_container_max_width: 772,
                    text_alignment: 'center',
                    button_text_font_size: pageStyles ? pageStyles.button_text_font_size : 16,
                    button_text_line_height: pageStyles ? pageStyles.button_text_line_height : 20,
                    button_border_radius: pageStyles ? pageStyles.button.button_border_radius : 4,
                    button_background_color: pageStyles ? pageStyles.button.button_background_color : '#EE8F00',
                    button_text_color: pageStyles ? pageStyles.button.button_text_color : '#FFFFFF',
                    button_shadow_position: pageStyles ? pageStyles.button.button_shadow_position : ShadowPosition.None,
                    button_shadow_color: pageStyles ? pageStyles.button.button_shadow_color : '#000000',
                    button_shadow_opacity: pageStyles ? pageStyles.button.button_shadow_opacity : .2,
                    price_container_background_color: '#FFFFFF',
                    price_container_border_color: '#D5D8DF',
                    price_container_border_width: 1,
                    price_container_width: undefined,
                    price_container_shadow_position: ShadowPosition.None,
                    price_container_shadow_color: '#000000',
                    price_container_shadow_opacity: .2,
                    list_style_type: ListStyleTypes.Disc,
                    list_marker_color: undefined,

                    //heading properties
                    heading_font_family: 'Arial, sans-serif',
                    heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    heading_font_size: 35,
                    heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    heading_line_height: 45,
                    heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    heading_color: '#000000',
                    heading_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
                    heading_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
                    heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
                    heading_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

                    //subtext properties
                    subtext_font_family: 'Arial, sans-serif',
                    subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    subtext_font_size: 20,
                    subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    subtext_line_height: 25,
                    subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    subtext_color: '#666666',
                    subtext_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#666666',
                    subtext_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#666666',
                    subtext_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#666666',
                    subtext_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#666666',

                    //price heading properties
                    price_heading_font_family: 'Arial, sans-serif',
                    price_heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',

                    price_heading_font_size: 27,
                    price_heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size: 27,

                    price_heading_line_height: 35,
                    price_heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,

                    price_heading_color: '#000000',
                    price_heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',

                    //price subtext properties
                    price_subtext_font_family: 'Arial, sans-serif',
                    price_subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    price_subtext_font_size: 20,
                    price_subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    price_subtext_line_height: 25,
                    price_subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    price_subtext_color: '#000000',
                    price_subtext_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

                    //price text properties
                    price_text_font_family: 'Arial, sans-serif',
                    price_text_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',

                    price_text_font_size: 27,
                    price_text_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size: 27,

                    price_text_line_height: 35,
                    price_text_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,

                    price_text_color: '#000000',
                    price_text_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
                },
                side_by_side_buttons: [],
            });
        case PageBlockTypes.Plans:
            return ({
                name: '',
                type: pageBlockType,
                heading: `<h1><strong>Plans</strong></h1>`,
                heading_json: `{"blocks":[{"key":"92iva","text":"Plans","type":"header-one","depth":0,"inlineStyleRanges":[{"offset":0,"length":5,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                subtext: '<p>Select subscription plans and pricing options to display their benefits on this page.</p>',
                subtext_json: `{"blocks":[{"key":"bpgvj","text":"Select subscription plans and pricing options to display their benefits on this page.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                plans: [],
                design: {
                    container_background_color: null,
                    container_padding_top: 20,
                    container_padding_bottom: 20,
                    content_container_max_width: 872,
                    content_container_alignment: 'left',
                    text_alignment: 'center',
                    list_style_type: ListStyleTypes.Disc,
                    list_marker_color: undefined,
                    cards_per_row: 2,
                    plan_container_background_color: '#FFFFFF',
                    plan_container_border_color: '#D5D8DF',
                    plan_container_border_width: 1,
                    plan_container_border_radius: 8,
                    plan_container_shadow_position: ShadowPosition.None,
                    plan_container_shadow_color: '#000000',
                    plan_container_shadow_opacity: .2,

                    //heading properties
                    heading_font_family: 'Arial, sans-serif',
                    heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    heading_font_size: 35,
                    heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    heading_line_height: 45,
                    heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    heading_color: '#000000',
                    heading_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
                    heading_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
                    heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
                    heading_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

                    //subtext properties
                    subtext_font_family: 'Arial, sans-serif',
                    subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    subtext_font_size: 20,
                    subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    subtext_line_height: 25,
                    subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    subtext_color: '#666666',
                    subtext_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#666666',
                    subtext_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#666666',
                    subtext_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#666666',
                    subtext_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#666666',

                    //plan name properties
                    plan_name_font_family: 'Arial, sans-serif',
                    plan_name_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    plan_name_font_size: 24,
                    plan_name_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 24,
                    
                    plan_name_line_height: 28,
                    plan_name_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 28,

                    plan_name_color: '#000000',
                    plan_name_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

                    plan_name_color_hover: '#000000',

                    //plan description properties
                    plan_description_font_family: 'Arial, sans-serif',
                    plan_description_font_size: 18, 
                    plan_description_line_height: 22,
                    plan_description_color: '#666666',
                    plan_description_color_hover: '#666666',

                    //plan price properties
                    plan_price_font_family: 'Arial, sans-serif',
                    plan_price_font_size: 18, 
                    plan_price_line_height: 22,
                    plan_price_color: '#000000',
                    plan_price_color_hover: '#000000',

                    //plan benefits title properties
                    plan_benefits_title_font_family: 'Arial, sans-serif',
                    plan_benefits_title_font_size: 16, 
                    plan_benefits_title_line_height: 18,
                    plan_benefits_title_color: '#333333',
                    plan_benefits_title_color_hover: '#333333',

                    //plan benefits text properties
                    plan_benefits_text_font_family: 'Arial, sans-serif',
                    plan_benefits_text_font_size: 14, 
                    plan_benefits_text_line_height: 18,
                    plan_benefits_text_color: '#666666',
                    plan_benefits_text_color_hover: '#666666',

                    plan_benefits_icon_color: '#365DE6',

                    button_text_font_size: pageStyles ? pageStyles.button_text_font_size : 16,
                    button_text_line_height: pageStyles ? pageStyles.button_text_line_height : 20,
                    button_border_radius: pageStyles ? pageStyles.button.button_border_radius : 4,
                    button_background_color: pageStyles ? pageStyles.button.button_background_color : '#EE8F00',
                    button_text_color: pageStyles ? pageStyles.button.button_text_color : '#FFFFFF',
                    button_shadow_position: pageStyles ? pageStyles.button.button_shadow_position : ShadowPosition.None,
                    button_shadow_color: pageStyles ? pageStyles.button.button_shadow_color : '#000000',
                    button_shadow_opacity: pageStyles ? pageStyles.button.button_shadow_opacity : .2,
                }
            });
        case PageBlockTypes.Event:
            return ({
                name: '',
                type: pageBlockType,
                image_alt: 'example banner',
                image_url: null,
                event_title: '',
                heading: '<h1><strong>Example Event Title</strong></h1>',
                heading_json: ``,
                subtext: '<p><strong>Select an event to add it to your page.</strong></p>',
                subtext_json: ``,
                subtext_tag: 'p',
                button_shown: true,
                button_action: ButtonAction.URL,
                button_text: '[Set button action]',
                button_url: '#',
                button_url_label: '',
                button_url_page_id: null,
                side_by_side_button: false,
                design: {
                    container_background_color: '#1f1e1d',
                    container_padding_top: 120,
                    container_padding_bottom: 120,
                    content_container_max_width: 772,
                    image_opacity: 1,
                    text_alignment: 'center',
                    button_text_font_size: pageStyles ? pageStyles.button_text_font_size : 16,
                    button_text_line_height: pageStyles ? pageStyles.button_text_line_height : 20,
                    button_border_radius: pageStyles ? pageStyles.button.button_border_radius : 4,
                    button_background_color: pageStyles ? pageStyles.button.button_background_color : '#EE8F00',
                    button_text_color: pageStyles ? pageStyles.button.button_text_color : '#FFFFFF',
                    button_shadow_position: pageStyles ? pageStyles.button.button_shadow_position : ShadowPosition.None,
                    button_shadow_color: pageStyles ? pageStyles.button.button_shadow_color : '#000000',
                    button_shadow_opacity: pageStyles ? pageStyles.button.button_shadow_opacity : .2,
                    list_style_type: ListStyleTypes.Disc,
                    list_marker_color: undefined,

                    //heading properties
                    heading_font_family: 'Arial, sans-serif',
                    heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    heading_font_size: 35,
                    heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    heading_line_height: 45,
                    heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    heading_color: '#FFFFFF',
                    heading_h1_color: '#FFFFFF',
                    heading_h2_color: '#FFFFFF',
                    heading_h3_color: '#FFFFFF',
                    heading_p_color: '#FFFFFF',

                    //subtext properties
                    subtext_font_family: 'Arial, sans-serif',
                    subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    subtext_font_size: 20,
                    subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    subtext_line_height: 25,
                    subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    subtext_color: '#FFFFFF',
                    subtext_h1_color: '#FFFFFF',
                    subtext_h2_color: '#FFFFFF',
                    subtext_h3_color: '#FFFFFF',
                    subtext_p_color: '#FFFFFF',
                },
                side_by_side_buttons: [],
            });
        case PageBlockTypes.Events:
            return ({
                name: '',
                type: pageBlockType,
                heading: `<h1>Upcoming Events</h1>`,
                heading_json: `{"blocks":[{"key":"92iva","text":"Upcoming Events","type":"header-one","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                subtext: `<p>Display your community's upcoming events.</p>`,
                subtext_json: `{"blocks":[{"key":"bpgvj","text":"Display your community\'s upcoming events.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                events_range: null,
                max_events_count: 6,
                design: {
                    container_background_color: null,
                    container_padding_top: 20,
                    container_padding_bottom: 20,
                    content_container_max_width: 872,
                    content_container_alignment: 'left',
                    text_alignment: 'center',
                    list_style_type: ListStyleTypes.Disc,
                    list_marker_color: undefined,
                    cards_per_row: 5,
                    event_container_background_color: '#FFFFFF',
                    event_container_border_color: '#D5D8DF',
                    event_container_border_width: 1,
                    event_container_border_radius: 8,
                    event_container_shadow_position: ShadowPosition.None,
                    event_container_shadow_color: '#000000',
                    event_container_shadow_opacity: .2,

                    //heading properties
                    heading_font_family: 'Arial, sans-serif',
                    heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    heading_font_size: 35,
                    heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    heading_line_height: 45,
                    heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    heading_color: '#000000',
                    heading_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
                    heading_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
                    heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
                    heading_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

                    //subtext properties
                    subtext_font_family: 'Arial, sans-serif',
                    subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    subtext_font_size: 20,
                    subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    subtext_line_height: 25,
                    subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    subtext_color: '#666666',
                    subtext_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#666666',
                    subtext_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#666666',
                    subtext_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#666666',
                    subtext_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#666666',

                    //event name properties
                    event_name_font_family: 'Arial, sans-serif',
                    event_name_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    event_name_font_size: 16,
                    event_name_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 16,
                    
                    event_name_line_height: 22,
                    event_name_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 22,

                    event_name_color: '#000000',
                    event_name_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

                    event_name_color_hover: '#365DE6',

                    //event time properties
                    event_time_font_family: 'Arial, sans-serif',
                    event_time_font_size: 14,
                    event_time_line_height: 21,
                    event_time_color: '#666666',

                    event_time_color_hover: '#365DE6',

                    //event attendees properties
                    event_attendees_font_family: 'Arial, sans-serif',
                    event_attendees_font_size: 14,
                    event_attendees_line_height: 21,
                    event_attendees_color: '#666666',

                    event_attendees_color_hover: '#365DE6',

                    //event countdown properties
                    event_countdown_font_family: 'Arial, sans-serif',
                    event_countdown_font_size: 13,
                    event_countdown_line_height: 18,
                    event_countdown_color: '#365DE6',

                    event_countdown_background_color: '#365DE626'
                }
            });
        case PageBlockTypes.CourseCurriculum:
            return ({
                name: '',
                type: pageBlockType,
                course_id: null,
                course_title: '',
                heading: `<h2><strong>Course Curriculum</strong></h2>`,
                heading_json: `{"blocks":[{"key":"e9rfm","text":"Course Curriculum","type":"header-two","depth":0,"inlineStyleRanges":[{"offset":0,"length":17,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                subtext: '<p>Select a course in your community and display the course outline.</p>',
                subtext_json: `{"blocks":[{"key":"bd1qb","text":"Select a course in your community and display the course outline.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                expanded: true,
                content: [],
                design: {
                    container_background_color: null,
                    container_padding_top: 20,
                    container_padding_bottom: 20,
                    content_container_max_width: 872,
                    section_container_background_color: '#EDEEF0',
                    section_container_shadow_position: ShadowPosition.None,
                    section_container_shadow_color: '#000000',
                    section_container_shadow_opacity: .2,
                    lesson_container_background_color: '#FFFFFF',
                    border_color: '#D5D8DF',
                    border_width: 1,
                    icon_color: '#767A8A',
                    text_alignment: 'center',
                    list_style_type: ListStyleTypes.Disc,
                    list_marker_color: undefined,

                    //heading properties
                    heading_font_family: 'Arial, sans-serif',
                    heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    heading_font_size: 35,
                    heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    heading_line_height: 45,
                    heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    heading_color: '#000000',
                    heading_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
                    heading_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
                    heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
                    heading_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

                    //subtext properties
                    subtext_font_family: 'Arial, sans-serif',
                    subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    subtext_font_size: 20,
                    subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    subtext_line_height: 25,
                    subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    subtext_color: '#666666',
                    subtext_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#666666',
                    subtext_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#666666',
                    subtext_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#666666',
                    subtext_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#666666',

                    //section name properties
                    section_name_font_family: 'Arial, sans-serif',
                    section_name_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    section_name_font_size: 20,
                    section_name_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,
                    
                    section_name_line_height: 25,
                    section_name_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    section_name_color: '#000000',
                    section_name_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

                    //lesson name properties
                    lesson_name_font_family: 'Arial, sans-serif',
                    lesson_name_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    lesson_name_font_size: 20,
                    lesson_name_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,
                    
                    lesson_name_line_height: 25,
                    lesson_name_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    lesson_name_color: '#000000',
                    lesson_name_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',
                }
            });
        case PageBlockTypes.Courses:
            return ({
                name: '',
                type: pageBlockType,
                heading: `<h1><strong>Courses</strong></h1>`,
                heading_json: `{"blocks":[{"key":"92iva","text":"Courses","type":"header-one","depth":0,"inlineStyleRanges":[{"offset":0,"length":7,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                subtext: '<p>Select courses in your community to display on this page.</p>',
                subtext_json: `{"blocks":[{"key":"bpgvj","text":"Select courses in your community to display on this page.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                courses: [],
                design: {
                    container_background_color: null,
                    container_padding_top: 20,
                    container_padding_bottom: 20,
                    content_container_max_width: 872,
                    content_container_alignment: 'left',
                    text_alignment: 'center',
                    list_style_type: ListStyleTypes.Disc,
                    list_marker_color: undefined,
                    cards_per_row: 3,
                    course_container_background_color: '#FFFFFF',
                    course_container_border_color: '#D5D8DF',
                    course_container_border_width: 1,
                    course_container_border_radius: 8,
                    course_container_shadow_position: ShadowPosition.None,
                    course_container_shadow_color: '#000000',
                    course_container_shadow_opacity: .2,

                    //heading properties
                    heading_font_family: 'Arial, sans-serif',
                    heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    heading_font_size: 35,
                    heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    heading_line_height: 45,
                    heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    heading_color: '#000000',
                    heading_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
                    heading_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
                    heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
                    heading_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

                    //subtext properties
                    subtext_font_family: 'Arial, sans-serif',
                    subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    subtext_font_size: 20,
                    subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    subtext_line_height: 25,
                    subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    subtext_color: '#666666',
                    subtext_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#666666',
                    subtext_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#666666',
                    subtext_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#666666',
                    subtext_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#666666',

                    //course name properties
                    course_name_font_family: 'Arial, sans-serif',
                    course_name_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    course_name_font_size: 20,
                    course_name_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 18,
                    
                    course_name_line_height: 25,
                    course_name_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 22,

                    course_name_color: '#000000',
                    course_name_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

                    course_name_color_hover: '#365DE6',
                }
            });
        case PageBlockTypes.FAQ:
            return ({
                name: '',
                type: pageBlockType,
                heading: `<h2><strong>Frequently Asked Questions</strong></h2>`,
                heading_json: ``,
                blocks: [
                    {
                        type: pageBlockType,
                        question: `<p>Use this text to write a question</p>`,
                        question_json: ``,
                        answer: `<p>Use this text to write an answer</p>`,
                        answer_json: ``,
                    },
                ],
                design: {
                    container_background_color: null,
                    container_padding_top: 20,
                    container_padding_bottom: 20,
                    content_container_max_width: 772,
                    text_alignment: 'center',
                    question_container_background_color: '#EEF5FF',
                    question_container_border_color: '#D5D8DF',
                    question_container_border_width: 1,
                    question_container_icon_color: '#D5D8DF',
                    answer_container_background_color: '#FFFFFF',
                    list_style_type: ListStyleTypes.Disc,
                    list_marker_color: undefined,

                    //heading properties
                    heading_font_family: 'Arial, sans-serif',
                    heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    heading_font_size: 35,
                    heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    heading_line_height: 45,
                    heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    heading_color: '#000000',
                    heading_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
                    heading_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
                    heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
                    heading_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

                    //question text properties
                    question_font_family: 'Arial, sans-serif',
                    question_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    question_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    question_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    question_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    question_font_size: 20,
                    question_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    question_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    question_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    question_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    question_line_height: 25,
                    question_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    question_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    question_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    question_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    question_color: '#000000',
                    question_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
                    question_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
                    question_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
                    question_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

                    //answer text properties
                    answer_font_family: 'Arial, sans-serif',
                    answer_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    answer_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    answer_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    answer_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    answer_font_size: 20,
                    answer_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    answer_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    answer_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    answer_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    answer_line_height: 25,
                    answer_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    answer_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    answer_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    answer_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    answer_color: '#000000',
                    answer_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
                    answer_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
                    answer_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
                    answer_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',
                },
            });
        case PageBlockTypes.CountdownTimer:
            return ({
                name: '',
                type: pageBlockType,
                timer_type: null,
                date: '',
                design: {
                    container_background_color: null,
                    container_padding_top: 20,
                    container_padding_bottom: 20,
                    content_container_max_width: 600,

                    date_font_family: 'Arial, sans-serif',
                    date_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',

                    date_font_size: 35,
                    date_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,

                    date_line_height: 45,
                    date_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,

                    date_color: '#333333',
                    date_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#333333',

                    date_label_font_family: 'Arial, sans-serif',
                    date_label_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    date_label_font_size: 20,
                    date_label_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    date_label_line_height: 25,
                    date_label_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    date_label_color: '#333333',
                    date_label_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#333333',
                },
            });
        case PageBlockTypes.Embed:
            return ({
                type: pageBlockType,
                embed_type: EmbedTypes.URL,
                embed_url: '',
                name: '',
                heading: '<h3><strong>Example Embed Title</strong></h3>',
                heading_json: ``,
                subtext: `<p>Set description on the Embed block</p>`,
                subtext_json: ``,
                button_action: ButtonAction.None,
                button_text: '[Set button action]',
                button_url: '#',
                button_url_label: '',
                button_url_page_id: null,
                design: {
                    text_alignment: 'center',
                    container_background_color: null,
                    container_padding_top: 30,
                    container_padding_bottom: 30,
                    content_container_max_width: 772,
                    button_text_font_size: pageStyles ? pageStyles.button_text_font_size : 16,
                    button_text_line_height: pageStyles ? pageStyles.button_text_line_height : 20,
                    button_border_radius: pageStyles ? pageStyles.button.button_border_radius : 4,
                    button_background_color: pageStyles ? pageStyles.button.button_background_color : '#EE8F00',
                    button_text_color: pageStyles ? pageStyles.button.button_text_color : '#FFFFFF',
        
                    //heading properties
                    heading_font_family: 'Arial, sans-serif',
                    heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',
        
                    heading_font_size: 35,
                    heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,
        
                    heading_line_height: 45,
                    heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,
        
                    heading_color: '#000000',
                    heading_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
                    heading_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
                    heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
                    heading_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',
        
                    //subtext properties
                    subtext_font_family: 'Arial, sans-serif',
                    subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',
        
                    subtext_font_size: 20,
                    subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,
        
                    subtext_line_height: 25,
                    subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,
        
                    subtext_color: '#666666',
                    subtext_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#666666',
                    subtext_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#666666',
                    subtext_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#666666',
                    subtext_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#666666',
                },
            });
        case PageBlockTypes.Form:
            return ({
                type: pageBlockType,
                name: '',
                heading: '<h3><strong>Example Form Title</strong></h3>',
                heading_json: ``,
                subtext: `<p>Set custom fields to collect page visitor's info</p>`,
                subtext_json: ``,
                submission_message: `<p>Thank you for your submission!</p>`,
                submission_message_json: ``,
                button_action: ButtonAction.None,
                button_text: '[Set button action]',
                button_url: '#',
                button_url_label: '',
                button_url_page_id: null,
                design: {
                    text_alignment: 'center',
                    container_background_color: '#FFFFFF',
                    container_padding_top: 30,
                    container_padding_bottom: 30,
                    content_container_max_width: 600,
                    content_wrapper_padding: 0,
                    content_wrapper_border_radius: 0,
                    content_wrapper_border_color: null,
                    content_wrapper_background_color: '#FFFFFF',
                    content_wrapper_shadow_position: ShadowPosition.None,
                    content_wrapper_shadow_color: '#333333',
                    content_wrapper_shadow_opacity: .2,
                    button_text_font_size: pageStyles ? pageStyles.button_text_font_size : 16,
                    button_text_line_height: pageStyles ? pageStyles.button_text_line_height : 20,
                    button_border_radius: pageStyles ? pageStyles.button.button_border_radius : 4,
                    button_background_color: pageStyles ? pageStyles.button.button_background_color : '#EE8F00',
                    button_text_color: pageStyles ? pageStyles.button.button_text_color : '#FFFFFF',
                    button_shadow_position: pageStyles ? pageStyles.button.button_shadow_position : ShadowPosition.None,
                    button_shadow_color: pageStyles ? pageStyles.button.button_shadow_color : '#000000',
                    button_shadow_opacity: pageStyles ? pageStyles.button.button_shadow_opacity : .2,
                    field_input_border_radius: 4,
                    field_input_border_color: '#D5D8DF',
                    field_input_label_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',
                    field_input_label_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,
                    field_input_label_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,
                    field_input_label_color: pageStyles ? pageStyles.fonts.p.text_color : '#333333',
                    field_input_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',
                    field_input_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,
                    field_input_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,
                    field_input_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',
                    field_input_height: 44,
                    field_input_background_color: '#FFFFFF',
                    field_input_placeholder_color: '#D1D1D1',
                    field_input_required_color: `#FF0000`,
        
                    //heading properties
                    heading_font_family: 'Arial, sans-serif',
                    heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',
        
                    heading_font_size: 35,
                    heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,
        
                    heading_line_height: 45,
                    heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,
        
                    heading_color: '#000000',
                    heading_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
                    heading_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
                    heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
                    heading_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',
        
                    //subtext properties
                    subtext_font_family: 'Arial, sans-serif',
                    subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',
        
                    subtext_font_size: 20,
                    subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,
        
                    subtext_line_height: 25,
                    subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,
        
                    subtext_color: '#666666',
                    subtext_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#666666',
                    subtext_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#666666',
                    subtext_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#666666',
                    subtext_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#666666',
        
                    //submission message properties
                    submission_message_font_family: 'Arial, sans-serif',
                    submission_message_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    submission_message_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    submission_message_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    submission_message_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',
        
                    submission_message_font_size: 20,
                    submission_message_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    submission_message_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    submission_message_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    submission_message_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,
        
                    submission_message_line_height: 25,
                    submission_message_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    submission_message_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    submission_message_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    submission_message_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,
        
                    submission_message_color: '#333333',
                    submission_message_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#333333',
                    submission_message_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#333333',
                    submission_message_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#333333',
                    submission_message_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#333333',
        
                    //user consent properties
                    user_consent_font_family: 'Arial, sans-serif',
                    user_consent_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    user_consent_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    user_consent_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    user_consent_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',
        
                    user_consent_font_size: 20,
                    user_consent_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    user_consent_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    user_consent_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    user_consent_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,
        
                    user_consent_line_height: 25,
                    user_consent_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    user_consent_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    user_consent_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    user_consent_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,
        
                    user_consent_color: '#333333',
                    user_consent_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#333333',
                    user_consent_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#333333',
                    user_consent_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#333333',
                    user_consent_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#333333',
                },
                fields: [
                    {
                        type: FormFieldTypes.Email,
                        label: FormFieldTypes.Email,
                        placeholder: FormFieldTypes.Email,
                        is_required: true,
                        error_message: "",
                    }
                ]
            });
        case PageBlockTypes.Payment:
            return ({
                name: '',
                type: pageBlockType,
                purpose: null,
                upsell_urgency_type: null,
                upsell_urgency_value: null,
                show_countdown: false,
                heading: '<h1><strong>Example Text</strong></h1>',
                heading_json: `{"blocks":[{"key":"92iva","text":"Example Text","type":"header-one","depth":0,"inlineStyleRanges":[{"offset":0,"length":12,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`,
                text: `<p>Allow page visitors to make payment for your community resources.</p>`,
                text_json: `{\"blocks\":[{\"key\":\"bpgvj\",\"text\":\"Allow page visitors to make payment for your community resources.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}`,
                purchase_container_title: `Complete payment`,
                upsell_resources: [],
                resource: null,
                resource_price_option: null,
                button_action: ButtonAction.URL,
                button_text: '[Set button action]',
                button_url: '#',
                button_url_label: '',
                button_url_page_id: null,
                skip_upsell_action: ButtonAction.URL,
                skip_upsell_text: 'No Thanks',
                skip_upsell_url: '#',
                skip_upsel_url_label: '',
                payment_successful_title: 'Transaction completed successfully',
                payment_successful_subtext: `<p>Thank you for your payment</p>`,
                payment_successful_subtext_json: `{\"blocks\":[{\"key\":\"bpgvj\",\"text\":\"Thank you for your payment\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}`,
                payment_invalid_title: 'Purchase unavailable',
                payment_invalid_subtext: `<p>This product is no longer on sale</p>`,
                payment_invalid_subtext_json: `{\"blocks\":[{\"key\":\"bpgvj\",\"text\":\"This product is no longer on sale\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}`,
                design: {
                    container_background_color: null,
                    container_padding_top: 20,
                    container_padding_bottom: 20,
                    content_container_max_width: 772,
                    text_alignment: 'center',
                    list_style_type: ListStyleTypes.Disc,
                    list_marker_color: undefined,

                    //heading properties
                    heading_font_family: 'Arial, sans-serif',
                    heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    heading_font_size: 35,
                    heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    heading_line_height: 45,
                    heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    heading_color: '#000000',
                    heading_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
                    heading_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
                    heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
                    heading_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

                    //subtext properties
                    subtext_font_family: 'Arial, sans-serif',
                    subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
                    subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
                    subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
                    subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

                    subtext_font_size: 20,
                    subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
                    subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
                    subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
                    subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

                    subtext_line_height: 25,
                    subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
                    subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
                    subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
                    subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

                    text_color: '#666666',
                    subtext_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#666666',
                    subtext_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#666666',
                    subtext_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#666666',
                    subtext_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#666666',

                    button_text_font_size: 15,
                    button_text_line_height: 18,
                    button_border_radius: pageStyles ? pageStyles.button.button_border_radius : 4,
                    button_background_color: '#365DE6',
                    button_text_color: pageStyles ? pageStyles.button.button_text_color : '#FFFFFF',
                    button_shadow_position: pageStyles ? pageStyles.button.button_shadow_position : ShadowPosition.None,
                    button_shadow_color: pageStyles ? pageStyles.button.button_shadow_color : '#000000',
                    button_shadow_opacity: pageStyles ? pageStyles.button.button_shadow_opacity : .2,

                    upsell_timer_text_font_family: 'Arial, sans-serif',
                    upsell_timer_text_font_size: 15,
                    upsell_timer_text_line_height: 18,
                    upsell_timer_text_color: '#000000',
                    upsell_timer_background_color: '#365DE6',
                    upsell_timer_icon_color: '#C03131',

                    skip_upsell_text_font_family: 'Arial, sans-serif',
                    skip_upsell_text_font_size: 15,
                    skip_upsell_text_line_height: 18,
                    skip_upsell_text_color: '#365DE6',
                },
            });
        default: 
            return ({});
    }
}

export const scrollElementIntoView = (elementId: string) => {
    const elementReference: HTMLElement = document.getElementById(elementId) as HTMLElement;

    if(elementReference) {
        elementReference.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }
}

export const getDefaultPageFormData = (pageStyles: any) => {
    return ({
        type: WidgetType.Form,
        name: '',
        heading: '<h3><strong>Example Popup Title</strong></h3>',
        heading_json: ``,
        subtext: `<p>Set custom fields to collect page visitor's info</p>`,
        subtext_json: ``,
        submission_message: `<p>Thank you for your submission!</p>`,
        submission_message_json: ``,
        button_action: ButtonAction.None,
        button_text: '[Set button action]',
        button_url: '#',
        button_url_label: '',
        button_url_page_id: null,
        design: {
            text_alignment: 'center',
            container_background_color: '#FFFFFF',
            container_padding_top: 30,
            container_padding_bottom: 30,
            container_width: 500,
            close_icon_color: '#333333',
            button_text_font_size: pageStyles ? pageStyles.button_text_font_size : 16,
            button_text_line_height: pageStyles ? pageStyles.button_text_line_height : 20,
            button_border_radius: pageStyles ? pageStyles.button.button_border_radius : 4,
            button_background_color: pageStyles ? pageStyles.button.button_background_color : '#EE8F00',
            button_text_color: pageStyles ? pageStyles.button.button_text_color : '#FFFFFF',
            button_shadow_position: pageStyles ? pageStyles.button.button_shadow_position : ShadowPosition.None,
            button_shadow_color: pageStyles ? pageStyles.button.button_shadow_color : '#000000',
            button_shadow_opacity: pageStyles ? pageStyles.button.button_shadow_opacity : .2,
            field_input_border_color: '#D5D8DF',
            field_input_label_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',
            field_input_label_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,
            field_input_label_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,
            field_input_label_color: pageStyles ? pageStyles.fonts.p.text_color : '#333333',
            field_input_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',
            field_input_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,
            field_input_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,
            field_input_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',
            field_input_height: 44,
            field_input_background_color: '#FFFFFF',
            field_input_placeholder_color: '#D1D1D1',
            field_input_required_color: `#FF0000`,
            dropdown_background_color: '#FFFFFF',
            dropdown_border_color: '#D5D8DF',
            dropdown_border_radius: 4,

            //heading properties
            heading_font_family: 'Arial, sans-serif',
            heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
            heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
            heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
            heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

            heading_font_size: 35,
            heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
            heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
            heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
            heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

            heading_line_height: 45,
            heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
            heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
            heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
            heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

            heading_color: '#000000',
            heading_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
            heading_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
            heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
            heading_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

            //subtext properties
            subtext_font_family: 'Arial, sans-serif',
            subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
            subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
            subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
            subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

            subtext_font_size: 20,
            subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
            subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
            subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
            subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

            subtext_line_height: 25,
            subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
            subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
            subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
            subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

            subtext_color: '#666666',
            subtext_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#666666',
            subtext_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#666666',
            subtext_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#666666',
            subtext_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#666666',

            //submission message properties
            submission_message_font_family: 'Arial, sans-serif',
            submission_message_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
            submission_message_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
            submission_message_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
            submission_message_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

            submission_message_font_size: 20,
            submission_message_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
            submission_message_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
            submission_message_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
            submission_message_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

            submission_message_line_height: 25,
            submission_message_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
            submission_message_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
            submission_message_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
            submission_message_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

            submission_message_color: '#333333',
            submission_message_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#333333',
            submission_message_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#333333',
            submission_message_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#333333',
            submission_message_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#333333',

            //user consent properties
            user_consent_font_family: 'Arial, sans-serif',
            user_consent_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
            user_consent_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
            user_consent_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
            user_consent_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

            user_consent_font_size: 20,
            user_consent_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
            user_consent_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
            user_consent_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
            user_consent_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

            user_consent_line_height: 25,
            user_consent_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
            user_consent_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
            user_consent_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
            user_consent_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

            user_consent_color: '#333333',
            user_consent_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#333333',
            user_consent_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#333333',
            user_consent_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#333333',
            user_consent_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#333333',
        },
        fields: [
            {
                type: FormFieldTypes.Email,
                label: FormFieldTypes.Email,
                placeholder: FormFieldTypes.Email,
                is_required: true,
                error_message: "",
            }
        ]
    });
}

export const getDefaultSchedulerData = (pageStyles: any) => {
    return ({
        type: WidgetType.Scheduler,
        scheduler_type: SchedulerTypes.Calendly,
        calendly_type: CalendlyType.Link,
        event_type: null,
        scheduler_url: '',
        name: '',
        heading: '<h3><strong>Example Scheduler App Title</strong></h3>',
        heading_json: ``,
        subtext: `<p>Set description on the Schedular App widget</p>`,
        subtext_json: ``,
        button_action: ButtonAction.None,
        button_text: '[Set button action]',
        button_url: '#',
        button_url_label: '',
        button_url_page_id: null,
        design: {
            text_alignment: 'center',
            container_background_color: '#FFFFFF',
            container_padding_top: 30,
            container_padding_bottom: 30,
            container_width: 500,
            close_icon_color: '#333333',
            button_text_font_size: pageStyles ? pageStyles.button_text_font_size : 16,
            button_text_line_height: pageStyles ? pageStyles.button_text_line_height : 20,
            button_border_radius: pageStyles ? pageStyles.button.button_border_radius : 4,
            button_background_color: pageStyles ? pageStyles.button.button_background_color : '#EE8F00',
            button_text_color: pageStyles ? pageStyles.button.button_text_color : '#FFFFFF',

            //heading properties
            heading_font_family: 'Arial, sans-serif',
            heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
            heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
            heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
            heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

            heading_font_size: 35,
            heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
            heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
            heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
            heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

            heading_line_height: 45,
            heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
            heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
            heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
            heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

            heading_color: '#000000',
            heading_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
            heading_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
            heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
            heading_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

            //subtext properties
            subtext_font_family: 'Arial, sans-serif',
            subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
            subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
            subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
            subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

            subtext_font_size: 20,
            subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
            subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
            subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
            subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

            subtext_line_height: 25,
            subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
            subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
            subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
            subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

            subtext_color: '#666666',
            subtext_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#666666',
            subtext_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#666666',
            subtext_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#666666',
            subtext_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#666666',
        },
    });
}

export const CALENDLY_PERSONAL_ACCESS_TOKEN_KIHARA: string = `eyJraWQiOiIxY2UxZTEzNjE3ZGNmNzY2YjNjZWJjY2Y4ZGM1YmFmYThhNjVlNjg0MDIzZjdjMzJiZTgzNDliMjM4MDEzNWI0IiwidHlwIjoiUEFUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNzI4NDc5MzY3LCJqdGkiOiIxMjY0YTgxMC04YzBlLTRjYzMtYmY5MS1kMmRiZjg1OThlODIiLCJ1c2VyX3V1aWQiOiI3MjE2MzFiNi02ZjFiLTQ2YWMtOGFlYS0yNTBkMzczZGZlNzEifQ.ZN3xOXsoPWxc-Hfdse5c_u8vdfPAVD7IdF7zE6p_H3UN_HTfjNCtddymj2DpPd34s5oKOBjkmnxVPM3O1Zmyxg`;
export const CALENDLY_PERSONAL_ACCESS_TOKEN_DORNUBARI: string = `eyJraWQiOiIxY2UxZTEzNjE3ZGNmNzY2YjNjZWJjY2Y4ZGM1YmFmYThhNjVlNjg0MDIzZjdjMzJiZTgzNDliMjM4MDEzNWI0IiwidHlwIjoiUEFUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNzI4NDg2NTUzLCJqdGkiOiIzODg1NDk2Ni0zNWNhLTQzYTUtYjcyYi02NzFkMDAzZjhiZjUiLCJ1c2VyX3V1aWQiOiJmZWY2NTg0ODgyMDFlOWU5NzM0OGFhYWM2ZGE1MTMwNCJ9.A1SZLgxDJreVVWYMz0dgKf0ndicJLpSeOy-N0R2L67PN3CeUpvYwZfxYB_JFQanRQ1l0yTSdy2eAsRW8g4bEzw`;

export const getDefaultEmbedData = (pageStyles: any) => {
    return ({
        type: WidgetType.Embed,
        embed_type: EmbedTypes.URL,
        embed_url: '',
        name: '',
        heading: '<h3><strong>Example Embed Title</strong></h3>',
        heading_json: ``,
        subtext: `<p>Set description on the Embed widget</p>`,
        subtext_json: ``,
        button_action: ButtonAction.None,
        button_text: '[Set button action]',
        button_url: '#',
        button_url_label: '',
        button_url_page_id: null,
        design: {
            text_alignment: 'center',
            container_background_color: '#FFFFFF',
            container_padding_top: 30,
            container_padding_bottom: 30,
            container_width: 500,
            close_icon_color: '#333333',
            button_text_font_size: pageStyles ? pageStyles.button_text_font_size : 16,
            button_text_line_height: pageStyles ? pageStyles.button_text_line_height : 20,
            button_border_radius: pageStyles ? pageStyles.button.button_border_radius : 4,
            button_background_color: pageStyles ? pageStyles.button.button_background_color : '#EE8F00',
            button_text_color: pageStyles ? pageStyles.button.button_text_color : '#FFFFFF',

            //heading properties
            heading_font_family: 'Arial, sans-serif',
            heading_h1_font_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
            heading_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
            heading_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
            heading_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

            heading_font_size: 35,
            heading_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
            heading_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
            heading_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
            heading_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

            heading_line_height: 45,
            heading_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
            heading_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
            heading_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
            heading_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

            heading_color: '#000000',
            heading_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#000000',
            heading_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#000000',
            heading_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#000000',
            heading_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#000000',

            //subtext properties
            subtext_font_family: 'Arial, sans-serif',
            subtext_font_h1_family: pageStyles ? pageStyles.fonts.h1.font_family : 'Arial, sans-serif',
            subtext_h2_font_family: pageStyles ? pageStyles.fonts.h2.font_family : 'Arial, sans-serif',
            subtext_h3_font_family: pageStyles ? pageStyles.fonts.h3.font_family : 'Arial, sans-serif',
            subtext_p_font_family: pageStyles ? pageStyles.fonts.p.font_family : 'Arial, sans-serif',

            subtext_font_size: 20,
            subtext_h1_font_size: pageStyles ? pageStyles.fonts.h1.font_size : 35,
            subtext_h2_font_size: pageStyles ? pageStyles.fonts.h2.font_size : 31,
            subtext_h3_font_size: pageStyles ? pageStyles.fonts.h3.font_size : 27,
            subtext_p_font_size: pageStyles ? pageStyles.fonts.p.font_size : 20,

            subtext_line_height: 25,
            subtext_h1_line_height: pageStyles ? pageStyles.fonts.h1.line_height : 45,
            subtext_h2_line_height: pageStyles ? pageStyles.fonts.h2.line_height : 40,
            subtext_h3_line_height: pageStyles ? pageStyles.fonts.h3.line_height : 35,
            subtext_p_line_height: pageStyles ? pageStyles.fonts.p.line_height : 25,

            subtext_color: '#666666',
            subtext_h1_color: pageStyles ? pageStyles.fonts.h1.text_color : '#666666',
            subtext_h2_color: pageStyles ? pageStyles.fonts.h2.text_color : '#666666',
            subtext_h3_color: pageStyles ? pageStyles.fonts.h3.text_color : '#666666',
            subtext_p_color: pageStyles ? pageStyles.fonts.p.text_color : '#666666',
        },
    });
}

export const hasBlock = (pageBlocks: Array<any>, blockType: PageBlockTypes) => {
        let hasTargetBlock: boolean = false;

        pageBlocks.forEach((pageBlock: any) => {
            if(pageBlock.type === blockType) {
                hasTargetBlock = true;
            }
        });

        return hasTargetBlock;
}

export const getPaymentBlockData = (pageBlocks: Array<any>) => {
    let paymentBlockData: any = null;

    pageBlocks.forEach((pageBlock: any) => {
        if(pageBlock.type === PageBlockTypes.Payment) {
            paymentBlockData = pageBlock;
        }
    });

    return paymentBlockData;
}

export const getDefaultHeaderData = (pageStyles: any) => {
    return ({
        type: PageNavElementTypes.Header,
        name: '',
        left: {
            logo_url: 'https://static.group.app/assets/page_header_groupapp_logo.png',
            image_action: ButtonAction.URL,
            image_link: '#',
            image_link_label: '',
            image_link_page_id: null,
        },
        center: {
            links: [
                {
                    name: '',
                    link_text: 'Home',
                    link_action: ButtonAction.URL,
                    link_url: '#',
                    link_url_label: '',
                    link_url_page_id: null,
                },
                {
                    name: '',
                    link_text: 'About',
                    link_action: ButtonAction.URL,
                    link_url: '#',
                    link_url_label: '',
                    link_url_page_id: null,
                },
                {
                    name: '',
                    link_text: 'Contacts',
                    link_action: ButtonAction.URL,
                    link_url: '#',
                    link_url_label: '',
                    link_url_page_id: null,
                },
            ],
        },
        right: {
            button_action: ButtonAction.URL,
            button_text: '[Link]',
            button_url: '#',
            button_url_label: '',
            button_url_page_id: null,
            side_by_side_button: false,
            side_by_side_buttons: [],
        },
        design: {
            header_behavior: HeaderBehavior.Static,
            container_background_color: null,
            container_padding_left: 20,
            container_padding_right: 20,
            container_height: 60,
            container_border_bottom_width: 0,
            container_border_bottom_color: null,
            container_shadow_color: null,
            container_shadow_opacity: null,
            content_container_max_width: 1150,

            logo_height: 50,

            link_text_font_family: 'Arial, sans-serif',
            link_text_font_size: 18,
            link_text_line_height: 25,
            link_text_color: '#365DE6',
            link_margin: 35,
            link_text_hover_color: null,

            button_text_font_size: pageStyles ? pageStyles.button_text_font_size : 16,
            button_text_line_height: pageStyles ? pageStyles.button_text_line_height : 20,
            button_border_radius: pageStyles ? pageStyles.button.button_border_radius : 4,
            button_background_color: pageStyles ? pageStyles.button.button_background_color : '#EE8F00',
            button_text_color: pageStyles ? pageStyles.button.button_text_color : '#FFFFFF',
            button_shadow_position: pageStyles ? pageStyles.button.button_shadow_position : ShadowPosition.None,
            button_shadow_color: pageStyles ? pageStyles.button.button_shadow_color : '#000000',
            button_shadow_opacity: pageStyles ? pageStyles.button.button_shadow_opacity : .2,
            button_border_width: 1,
            button_border_color: '#EE8F00',

            menu_icon_color: '#000000',
        },
    })
}

export const getDefaultFooterData = (pageStyles: any) => {
    return ({
        type: PageNavElementTypes.Footer,
        name: '',
        left: {
            logo_url: 'https://static.group.app/assets/page_header_groupapp_logo.png',
            image_action: ButtonAction.URL,
            image_link: '#',
            image_link_label: '',
            image_link_page_id: null,
        },
        center: {
            links: [
                {
                    link_text: 'Home',
                    link_action: ButtonAction.URL,
                    link_url: '#',
                    link_url_label: '',
                    link_url_page_id: null,
                },
                {
                    link_text: 'About',
                    link_action: ButtonAction.URL,
                    link_url: '#',
                    link_url_label: '',
                    link_url_page_id: null,
                },
                {
                    link_text: 'Contacts',
                    link_action: ButtonAction.URL,
                    link_url: '#',
                    link_url_label: '',
                    link_url_page_id: null,
                },
            ],
        },
        right: {
            socials: [
                {
                    type: Socials.Facebook,
                    link_url: '#',
                    link_url_label: '',
                    link_url_page_id: null,
                },
                {
                    type: Socials.X,
                    link_url: '#',
                    link_url_label: '',
                    link_url_page_id: null,
                },
                {
                    type: Socials.LinkedIn,
                    link_url: '#',
                    link_url_label: '',
                    link_url_page_id: null,
                },
            ]
        },
        meta: {
            show: false,
            links: [
                {
                    type: LegalLinkTypes.PrivacyPolicy,
                    link_text: 'Privacy policy',
                    link_action: ButtonAction.URL,
                    link_url: '#',
                    link_url_label: '',
                    link_url_page_id: null,
                },
                {
                    type: LegalLinkTypes.TermsOfService,
                    link_text: 'Terms of service',
                    link_action: ButtonAction.URL,
                    link_url: '#',
                    link_url_label: '',
                    link_url_page_id: null,
                },
                {
                    type: LegalLinkTypes.Cookies,
                    link_text: 'Cookies',
                    link_action: ButtonAction.URL,
                    link_url: '#',
                    link_url_label: '',
                    link_url_page_id: null,
                },
            ],
        },
        app_download: {
            show: false,
            title: 'App download',
            links: [
                {
                    type: Stores.AppStore,
                    image_url: 'https://www.group.app/wp-content/uploads/2023/02/appstore_.svg',
                    link_action: ButtonAction.URL,
                    link_url: '#',
                    link_url_label: '',
                    link_url_page_id: null,
                },
                {
                    type: Stores.PlayStore,
                    image_url: 'https://www.group.app/wp-content/uploads/2023/02/google-play.svg',
                    link_action: ButtonAction.URL,
                    link_url: '#',
                    link_url_label: '',
                    link_url_page_id: null,
                },
            ]
        },
        design: {
            container_background_color: null,
            container_padding_left: 20,
            container_padding_right: 20,
            container_padding_top: 50,
            container_padding_bottom: 50,
            content_container_max_width: 1150,

            logo_height: 50,

            link_text_font_family: 'Arial, sans-serif',
            link_text_font_size: 18,
            link_text_line_height: 25,
            link_text_color: '#365DE6',
            link_margin: 35,
            link_text_hover_color: null,

            label_text_font_family: 'Arial, sans-serif',
            label_text_font_size: 18,
            label_text_line_height: 25,
            label_text_color: '#365DE6',

            social_icon_size: 35,
            social_icon_color: '#000000',

            app_download_image_width: 100,

            meta_container_border_top_width: 1,
            meta_container_border_top_color: '#D5D8Df',
        },
    })
}

export const getSinglePage = (groupId: any, pageId: any, onSuccess: any) => {
    PageBuilderService.getInstance()
    .getSinglePage(groupId, pageId)
    .then((response: any) => {
        onSuccess(response.data);
    })
    .catch((error: any) => console.error(error))
    .finally(() => {});
}
